import { Fragment, type FC } from 'react';

import { ThrowError } from '#apps/client-web/app/components/throw-error';

import { type LoggingContext } from '#packages/data-collection/types/logging-context';
import { type ViewModelProps } from '#packages/web/types/view-model-props';
import { LoadingPage } from '#packages/web/layouts/page/templates';
import { DeleteConfirmationDialog } from '#packages/web/layouts/dialog/templates/delete-confirmation';

import { type AuditFormWaterFixtureEntryPageViewModel } from './audit-form-water-fixture-entry-page.view-model';
import { AuditFormWaterFixtureEntryPageRenderer } from './audit-form-water-fixture-entry-page.renderer';

export type AuditFormWaterFixtureEntryPageContainerProps =
  ViewModelProps<AuditFormWaterFixtureEntryPageViewModel> & LoggingContext;

export const AuditFormWaterFixtureEntryPageContainer: FC<
  AuditFormWaterFixtureEntryPageContainerProps
> = ({ viewModel }) => {
  const {
    loadAuditFormState,
    updateMutationState,
    form,
    deleteDialog,
    onDelete,
    onSubmit,
  } = viewModel;

  return (
    <Fragment>
      {/* Loading */}
      {loadAuditFormState.state === 'loading' && <LoadingPage />}

      {/* Success */}
      {loadAuditFormState.state === 'success' && (
        <AuditFormWaterFixtureEntryPageRenderer
          changeFixtureType={viewModel.changeFixtureType}
          form={form}
          onSubmit={onSubmit}
          isPending={updateMutationState.state === 'pending'}
        />
      )}

      {/* Error */}
      {loadAuditFormState.state === 'error' && (
        <ThrowError error={loadAuditFormState.error} />
      )}

      {/* Mutation error */}
      {updateMutationState.state === 'error' && (
        <ThrowError error={updateMutationState.error} />
      )}

      {/* Delete Dialog */}
      {deleteDialog.isOpen && (
        <DeleteConfirmationDialog
          open
          onCancel={deleteDialog.close}
          onConfirm={onDelete.bind(null, { confirmed: true })}
        />
      )}
    </Fragment>
  );
};
